import { DiagramUtils } from "../diagram/diagram-assets/DiagramUtils";
import { AnchoredPluginsHandler } from "../views/grid/modules/AnchoredPluginsHandler";
import { getInstanceIDFromCanvasInstance } from "../diagram/diagram-assets/diagram-positioning-state";

/**
 * @description Fabric plugin class. All plugins extend this.
 */
export class FabricPlugin {
    // plugin position {x,y}
    position;

    // plugin size {width, height}
    size;

    // canvas 2d context
    ctx;

    // plugin data - uuid
    data = {};

    // how many connectors are allowed
    points = {
        start: 0,
        end: 0,
        initial: 0
    };

    // plugin uuid
    uuid;

    // indicates if it has its own state
    hasOwnState = false;

    //  anchoredPluginHandler  instance
    anchoredPluginHandler;

    constructor(options, ctx, data) {
        this.data = data || {};
        if (this.data.uuid) this.uuid = this.data.uuid;
        else {
            this.uuid = new DiagramUtils().generateUUID();
            this.data.uuid = this.uuid;
        }
        this.position = options.position;
        this.size = options.size;
        this.ctx = ctx;
        this.anchoredPluginHandler = new AnchoredPluginsHandler(getInstanceIDFromCanvasInstance(this.ctx));
        return this;
    }

    fabricPluginRedrawed() {
        this.anchoredPluginHandler.pluginRedrawed(this.uuid);
    }

    fabricPluginUpdated() {
        this.anchoredPluginHandler.pluginUpdated(this.uuid);
    }

    getData() {
        return this.data;
    }

    setData(data) {
        this.data = data;
    }

    getPosition() {
        return { ...this.position };
    }

    setPosition(position) {
        this.position = position;
        this.fabricPluginUpdated();
    }

    getSize() {
        return { ...this.size };
    }

    setSize(size) {
        this.size = size;
        this.fabricPluginUpdated();
    }

    getMaxStartPoints() {
        return this.points.start;
    }

    hasOwnState() {
        return this.hasOwnState;
    }

    getMaxEndPoints() {
        return this.points.end;
    }
}
